import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import ActorCharacterFace from '../../../domain/entities/ActorCharacterFace';

export default function reducer(
  state: {[key: number]: ActorCharacterFace} = {},
  action: AnyAction,
): {[key: number]: ActorCharacterFace} {
  switch (action.type) {
    case Types.IndexActorCharacterFacesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: ActorCharacterFace},
            record: ActorCharacterFace,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowActorCharacterFaceSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
